enum MessageStatus {
  InProgress = 0,
  Sent = 1,
  Delivered = 2,
  Read = 3,
  Failed = 4,
}

interface Message {
  Id: string,
  Text: string,
  Status: MessageStatus,
  IsBankMessage: boolean,
  CreatedAt: any | Date
}
type MessageDataPayload = {
  ClientId: any,
}

export { Message, MessageStatus, MessageDataPayload }